import { SERVICE } from './constant'

export const LOAD_CONTRACT_STATUS_START = `${SERVICE}/LOAD_CONTRACT_STATUS_START`
export const LOAD_CONTRACT_STATUS_SUCCESS = `${SERVICE}/LOAD_CONTRACT_STATUS_SUCCESS`
export const LOAD_CONTRACT_STATUS_ERROR = `${SERVICE}/LOAD_CONTRACT_STATUS_ERROR`
export const LOAD_CONTROL_CLEAR = `${SERVICE}/LOAD_CONTROL_CLEAR`
export const FETCH_CONTRACT_STATUS = `${SERVICE}/FETCH_CONTRACT_STATUS`
export const SET_CONTRACT_STATUS = `${SERVICE}/SET_CONTRACT_STATUS`
export const CLEAR_CONTRACT_STATUS = `${SERVICE}/CLEAR_CONTRACT_STATUS`
